import { promptVars } from '../variables';
import { schemaBasePrompt } from './schemaBasePrompt';
export const schemaTempModelGeneratePrompt = schemaBasePrompt
    .model('eu.anthropic.claude-3-5-sonnet-20240620-v1:0')
    .temp(0.5)
    .human(`Generate ORM-DSL for following application:

# Application specification
${promptVars.specification}
`);
//# sourceMappingURL=schemaTempModelGeneratePrompt.js.map